import httpClientService from '../httpClientService';

class ProjectGridsService {
	getCustomTableById(id, entityId) {
		return httpClientService.Get(
			`/ProjectGridsModule/api/CustomTables/${id}?entityId=${entityId}`
		);
	}
	addCustomTable(item, entityId, process) {
		return httpClientService.PostMultiPart(
			`/ProjectGridsModule/api/CustomTables/?process=${process}&entityId=${entityId}`,
			item
		);
	}
	updateCustomTable(item, entityId, process) {
		return httpClientService.PutMultiPart(
			`/ProjectGridsModule/api/CustomTables/?process=${process}&entityId=${entityId}`,
			item
		);
	}
	deleteCustomTable(id, entityId, process) {
		return httpClientService.Delete(
			`/ProjectGridsModule/api/CustomTables/${id}?process=${process}&entityId=${entityId}`
		);
	}
	deleteBulkCustomTable(items, entityId, process) {
		return httpClientService.Delete(
			`/ProjectGridsModule/api/CustomTables/BulkDelete?process=${process}&entityId=${entityId}`,
			items
		);
	}

	getAssetById(id) {
		return httpClientService.Get(`/ProjectGridsModule/api/Assets/${id}`);
	}
	addAsset(asset, process) {
		return httpClientService.PostMultiPart(
			`/ProjectGridsModule/api/Assets/?process=${process}`,
			asset
		);
	}
	updateAsset(asset, process) {
		return httpClientService.PutMultiPart(
			`/ProjectGridsModule/api/Assets/?process=${process}`,
			asset
		);
	}
	deleteAsset(id, process) {
		return httpClientService.Delete(
			`/ProjectGridsModule/api/Assets/${id}?process=${process}`
		);
	}
	deleteBulkAsset(items, process) {
		return httpClientService.Delete(
			`/ProjectGridsModule/api/Assets/BulkDelete?process=${process}`,
			items
		);
	}

	getCatalogById(id) {
		return httpClientService.Get(`/ProjectGridsModule/api/Catalogs/${id}`);
	}
	addCatalog(item, process) {
		return httpClientService.PostMultiPart(
			`/ProjectGridsModule/api/Catalogs/?process=${process}`,
			item
		);
	}
	updateCatalog(item, process) {
		return httpClientService.PutMultiPart(
			`/ProjectGridsModule/api/Catalogs/?process=${process}`,
			item
		);
	}
	deleteCatalog(id, process) {
		return httpClientService.Delete(
			`/ProjectGridsModule/api/Catalogs/${id}?process=${process}`
		);
	}
	deleteBulkCatalog(items, process) {
		return httpClientService.Delete(
			`/ProjectGridsModule/api/Catalogs/BulkDelete?process=${process}`,
			items
		);
	}

	getDepartmentById(id) {
		return httpClientService.Get(
			`/ProjectGridsModule/api/Departments/${id}`
		);
	}
	addDepartment(item, process) {
		return httpClientService.PostMultiPart(
			`/ProjectGridsModule/api/Departments/?process=${process}`,
			item
		);
	}
	updateDepartment(item, process) {
		return httpClientService.PutMultiPart(
			`/ProjectGridsModule/api/Departments/?process=${process}`,
			item
		);
	}
	deleteDepartment(id, process) {
		return httpClientService.Delete(
			`/ProjectGridsModule/api/Departments/${id}?process=${process}`
		);
	}
	deleteBulkDepartment(items, process) {
		return httpClientService.Delete(
			`/ProjectGridsModule/api/Departments/BulkDelete?process=${process}`,
			items
		);
	}

	getLocationById(id) {
		return httpClientService.Get(`/ProjectGridsModule/api/Locations/${id}`);
	}
	addLocation(item, process) {
		return httpClientService.PostMultiPart(
			`/ProjectGridsModule/api/Locations/?process=${process}`,
			item
		);
	}
	updateLocation(item, process) {
		return httpClientService.PutMultiPart(
			`/ProjectGridsModule/api/Locations/?process=${process}`,
			item
		);
	}
	deleteLocation(id, process) {
		return httpClientService.Delete(
			`/ProjectGridsModule/api/Locations/${id}?process=${process}`
		);
	}
	deleteBulkLocation(items, process) {
		return httpClientService.Delete(
			`/ProjectGridsModule/api/Locations/BulkDelete?process=${process}`,
			items
		);
	}

	getNameById(id) {
		return httpClientService.Get(`/ProjectGridsModule/api/Names/${id}`);
	}
	addName(item, process) {
		return httpClientService.PostMultiPart(
			`/ProjectGridsModule/api/Names/?process=${process}`,
			item
		);
	}
	updateName(item, process) {
		return httpClientService.PutMultiPart(
			`/ProjectGridsModule/api/Names/?process=${process}`,
			item
		);
	}
	deleteName(id, process) {
		return httpClientService.Delete(
			`/ProjectGridsModule/api/Names/${id}?process=${process}`
		);
	}
	deleteBulkName(items, process) {
		return httpClientService.Delete(
			`/ProjectGridsModule/api/Names/BulkDelete?process=${process}`,
			items
		);
	}

	getEntities() {
		return httpClientService.Get('/ProjectGridsModule/api/Entities');
	}
	getReferenceListTypes() {
		return httpClientService.Get(
			'/ProjectGridsModule/api/ReferenceListTypes'
		);
	}
	getReferenceListValues() {
		return httpClientService.Get(
			'/ProjectGridsModule/api/ReferenceListValues'
		);
	}
	getReferenceListValuesByTypeId(referenceListTypeId) {
		return httpClientService.Get(
			`/ProjectGridsModule/api/ReferenceListValues?typeId=${referenceListTypeId}`
		);
	}

	getGridFields() {
		return httpClientService.Get('/ProjectGridsModule/api/GridViewField');
	}
	getGridField(id) {
		return httpClientService.Get(
			`/ProjectGridsModule/api/GridViewField/${id}`
		);
	}
	postGridField(field) {
		return httpClientService.Post(
			`/ProjectGridsModule/api/GridViewField/`,
			field
		);
	}
	putGridField(field) {
		return httpClientService.Put(
			`/ProjectGridsModule/api/GridViewField/`,
			field
		);
	}
	checkGridField(field) {
		return httpClientService.Post(
			'/ProjectGridsModule/api/GridViewField/IsLinkFieldCheck/',
			field
		);
	}
	deleteGridField(id) {
		return httpClientService.Delete(
			`/ProjectGridsModule/api/GridViewField/${id}`
		);
	}

	getGridViews() {
		return httpClientService.Get('/ProjectGridsModule/api/GridViews');
	}
	getGridViewById(id) {
		return httpClientService.Get(`/ProjectGridsModule/api/GridViews/${id}`);
	}
	loadData(params) {
		return httpClientService.Post(
			'/ProjectGridsModule/api/GridViews/LoadData',
			params
		);
	}
	loadDataById(gridViewId, itemId) {
		return httpClientService.Get(
			`/ProjectGridsModule/api/GridViews/LoadDataById?gridViewId=${gridViewId}&itemId=${itemId}`
		);
	}
	loadDataHistory(params) {
		return httpClientService.Post(
			'/ProjectGridsModule/api/GridViewHistory/LoadData',
			params
		);
	}
	loadDataUserHistory(params) {
		return httpClientService.Post(
			'/ProjectGridsModule/api/GridViewHistory/LoadDataUser',
			params
		);
	}

	saveView(params) {
		return httpClientService.Post(
			'/ProjectGridsModule/api/GridViews',
			params
		);
	}
	updateView(params) {
		return httpClientService.Put(
			'/ProjectGridsModule/api/GridViews',
			params
		);
	}
	updateColumns(param1, param2) {
		let data = { GridViewId: param1, Columns: param2 };
		return httpClientService.Post(
			'/ProjectGridsModule/api/GridViews/SetVisibleColumns',
			data
		);
	}
	setDefaultView(gridId) {
		return httpClientService.Post(
			`/ProjectGridsModule/api/GridViews/SetAsDefaultView/${gridId}`
		);
	}
	setGlobalView(gridId, isGlobal) {
		return httpClientService.Post(
			`/ProjectGridsModule/api/GridViews/SetGlobalView/${gridId}?isGlobal=${isGlobal}`
		);
	}
	deleteView(gridId) {
		return httpClientService.Delete(
			`/ProjectGridsModule/api/GridViews/${gridId}`
		);
	}

	getDefaultGridViewForEntity(entityId) {
		return httpClientService.Get(
			`/ProjectGridsModule/api/GridViews/GetDefaultGridViewForEntity?entityId=${entityId}`
		);
	}
	getDataFields() {
		return httpClientService.Get('/ProjectGridsModule/api/DataFields');
	}

	getMergeConditionsForEntityId(entityId) {
		return httpClientService.Get(
			`/ProjectGridsModule/api/MergeCondition?entityId=${entityId}`
		);
	}

	exportGridData(params) {
		return httpClientService.PostForExport(
			'/ProjectGridsModule/api/Export/ExportExcel',
			params
		);
	}

	loadUsers(filter) {
		if (filter) {
			return httpClientService.Get(
				`/ProjectGridsModule/api/User?filter=${filter}`
			);
		} else {
			return httpClientService.Get(`ProjectGridsModule/api/User`);
		}
	}
	loadUserById(id) {
		return httpClientService.Get(`/ProjectGridsModule/api/User/${id}`);
	}
	bulkEdit(payload) {
		return httpClientService.Post(
			'/ProjectGridsModule/api/BulkEdit',
			payload
		);
	}
	bulkRestore(payload) {
		return httpClientService.Put(
			'/ProjectGridsModule/api/BulkEdit/BulkRestore',
			payload
		);
	}
	getGridRecord(id, selectedEntity) {
		let entityType = selectedEntity.Name;
		switch (entityType) {
			case 'Asset':
				return this.getAssetById(id);
			case 'Catalog':
				return this.getCatalogById(id);
			case 'Department':
				return this.getDepartmentById(id);
			case 'Name':
				return this.getNameById(id);
			case 'Location':
				return this.getLocationById(id);
			default:
				//TODO
				return this.getCustomTableById(id, selectedEntity.Id);
		}
	}

	postGridAsset(item, selectedEntity, process) {
		let entityType = selectedEntity.Name;
		switch (entityType) {
			case 'Asset':
				return this.addAsset(item, process);
			case 'Catalog':
				return this.addCatalog(item, process);
			case 'Department':
				return this.addDepartment(item, process);
			case 'Name':
				return this.addName(item, process);
			case 'Location':
				return this.addLocation(item, process);
			default:
				return this.addCustomTable(item, selectedEntity.Id, process);
		}
	}

	putGridAsset(item, selectedEntity, process) {
		let entityType = selectedEntity.Name;
		switch (entityType) {
			case 'Asset':
				return this.updateAsset(item, process);
			case 'Catalog':
				return this.updateCatalog(item, process);
			case 'Department':
				return this.updateDepartment(item, process);
			case 'Name':
				return this.updateName(item, process);
			case 'Location':
				return this.updateLocation(item, process);
			default:
				//TODO
				return this.updateCustomTable(item, selectedEntity.Id, process);
		}
	}
	deleteGridAsset(id, entityType, entityId, process) {
		switch (entityType) {
			case 'Asset':
				return this.deleteAsset(id, process);
			case 'Catalog':
				return this.deleteCatalog(id, process);
			case 'Department':
				return this.deleteDepartment(id, process);
			case 'Name':
				return this.deleteName(id, process);
			case 'Location':
				return this.deleteLocation(id, process);
			default:
				//TODO
				return this.deleteCustomTable(id, entityId, process);
		}
	}
	deleteBulkGridAsset(id, entityType, entityId, process) {
		switch (entityType) {
			case 'Asset':
				return this.deleteBulkAsset(id, process);
			case 'Catalog':
				return this.deleteBulkCatalog(id, process);
			case 'Department':
				return this.deleteBulkDepartment(id, process);
			case 'Name':
				return this.deleteBulkName(id, process);
			case 'Location':
				return this.deleteBulkLocation(id, process);
			default:
				//TODO
				return this.deleteBulkCustomTable(id, entityId, process);
		}
	}

	getGridAssetHistory(requestData) {
		return this.loadDataHistory(requestData);
	}

	// Merge Records functionality
	getMergeDependencies(entityId, items) {
		const payload = {
			EntityId: entityId,
			Items: items,
		};
		return httpClientService.Post(
			'/ProjectGridsModule/api/MergeRecords/mergeDependencies',
			payload
		);
	}

	mergeRecords(entityId, primaryRecordId, items) {
		const payload = {
			EntityId: entityId,
			PrimaryRecordId: primaryRecordId,
			Items: items,
		};
		return httpClientService.Post(
			'/ProjectGridsModule/api/MergeRecords/merge',
			payload
		);
	}
}
const projectGridsService = new ProjectGridsService();
export default projectGridsService;
